import { useNavigate, useParams } from "react-router";
import { z } from "zod";
import { useQuery } from "@tanstack/react-query";
import { groupQueryOptions } from "@/api/Activities";
import { ActivityOccurrence } from "../ActivityOccurrence/ActivityOccurrence";
import {
  BackButton,
  CloseButton,
} from "@/components/NavigationButtons/NavigationButtons";

export const ActivityOccurrenceInGroupRoute = () => {
  const { activityId, occurrenceId, groupId } = z
    .object({
      activityId: z.string(),
      occurrenceId: z.string(),
      groupId: z.string(),
    })
    .parse(useParams());
  const navigate = useNavigate();

  const { data: group } = useQuery(groupQueryOptions(groupId));

  return (
    <ActivityOccurrence
      activityId={activityId}
      occurrenceId={occurrenceId}
      closeActivityOccurrencePanel={() => navigate("../..")}
      navigationButtonsInHeader={{
        backButton: <BackButton navigateBack={() => navigate("..")} />,
        closeButton: <CloseButton close={() => navigate("../..")} />,
      }}
      visitStatus={group?.visitStatus ?? undefined}
    />
  );
};
